import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onBeforeUnmount } from 'vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import { useRoute } from 'vue-router/composables'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BackgroundTile',
  setup(__props) {

  const route = useRoute()
  const { current } = useBreakpoint()
  const windowHeight = ref('100vh')

  const routePath = computed(() => {
    return route.path
  })

  watch(current, () => {
    windowHeight.value = '100vh'
  })

  watch(routePath, () => {
    setTimeout(() => {
      windowHeight.value = '100vh'
    }, 500)
  })

  const setScrollHeight = (value: string) => {
    windowHeight.value = value
  }

  const scrollHandler = () => {
    setScrollHeight(`${document.documentElement.scrollHeight}px`)
  }

  onMounted(() => {
    setScrollHeight(`${document.documentElement.scrollHeight}px`)
    window.addEventListener('scroll', scrollHandler)
    eventBus.$on('reset-background-tile-height', () => {
      setScrollHeight('100vh')
    })
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', scrollHandler)
  })

return { __sfc: true,route, current, windowHeight, routePath, setScrollHeight, scrollHandler, computed, ref, watch, onMounted, onBeforeUnmount, useBreakpoint, useRoute, eventBus }
}

})